module.exports = __webpack_public_path__ + "img/inflation-lock.c57cae9d.svg";